var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes, style: _vm.styles }, [
    _c(
      "div",
      { ref: "wrapper", staticClass: "trbo-a-animation-height__wrapper" },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }